import React from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS } from '@contentful/rich-text-types'
import get from 'lodash/get'

export function renderRichText(json, embeddedEntries) {
    const options = {
      renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
          const { title, description, file } = node.data.target.fields;
          const mimeType = file['en-US'].contentType
          const mimeGroup = mimeType.split('/')[0]

          if (mimeGroup === 'image') {
            return <img
              title={ title ? title['en-US'] : null}
              alt={description ?  description['en-US'] : null}
              src={file['en-US'].url}
            />
          } else {
            return null
          }
        },
        [BLOCKS.EMBEDDED_ENTRY]: (node) => {
          const type = get(node, 'data.target.sys.contentType.sys.id')

          const types = {
            // You can add global embeddable entry types here
            ...embeddedEntries
          }

          if (type in types) {
            return types[type](node)
          } else {
            return null
          }
        }
      }
    }


    return documentToReactComponents(json, options)
}
